import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('notification');
export const actions = helper.createActions('notification', actionTypes);
